import React, { Component } from 'react';
import { toUSD } from '../../helpers/formatters';
import { paymentFrequency } from '../../helpers/app';
import PayixButton from '../../containers/payix-button';

// Import assets
import warningIcon from '../../assets/images/warning.png';

class AchTermsConditions extends Component {
  handleSubmit = () => {
    let data = undefined;
    let props = this.props;

    if (this.props.isSchedule) {
      data = {
        date: props.scheduleDate,
        frequency: props.frequency,
        amount: props.amount
      }
    }

    this.props.onSubmit(data);
  }

  /**
   * Render additional information when the action is to schedule a payment.
   */
  renderExtraInfoForSchedule() {
    let markup = (
      <div>
        <div className="form-group form-group--row-layout">
          <p className="size-50per no-margin">Payment Start Date: <span className="gothammedium-font">{this.props.scheduleDate}</span></p>
          { 
            (this.props.frequency !== 'onlyonce') 
            ? <p className="size-50per no-margin">Frequency: <span className="gothammedium-font">{paymentFrequency(this.props.frequency)}</span></p>
            : null
          }
        </div>

        { 
          (this.props.frequency !== 'onlyonce') 
          ? <div className="form-group form-group--row-layout">
              <p className="size-50per no-margin">Number of Recurring Payments: <span className="gothammedium-font">{this.props.paymentsNumber}</span></p>
            </div>
          : null
        }
      </div>
    );

    return markup;
  }

  /**
   * Render the component view.
   */
  render() {
    let { company } = this.props;

    return (
      <div>
        <div className="modal__header">
          <div className="modal__header-content--centered">
            <img src={ warningIcon } alt="" />
          </div>
        </div>

        <div className="modal__body">
          <div className="modal__body-content--pad35">
            <p className="ach-terms gothambook-font">
              By clicking on <span className="gothammedium-font">“Submit”</span> I agree to each of the following: 
              <br /><br />
              I hereby authorize <span className="gothammedium-font">{company.name} ({company.website})</span> to initiate an electronic withdrawal 
              from the bank account or an electronic transaction to the debit card set forth below, in such amount 
              and on such date as set forth below. If I am setting up a payment schedule (recurring transactions), 
              I authorize the electronic bank account withdrawals or debit card transactions for the amount and with such frequency 
              set forth below. I understand that if this is a one-time transaction submitted after 5:00 PM eastern time, 
              it may have an effective date of the next business-banking day and may show as a withdrawal from my account on that date. 
              <br /><br />
              If the payment (or if I am authorizing a payment schedule, any future payment) is rejected by my financial institution 
              or card issuer for any reason, including without limitation insufficient funds, I understand 
              and agree that <span className="gothammedium-font">{company.name}</span> may in its discretion attempt to process that payment again within 30 days. 
              I also agree that an NSF charge may apply and be charged separately. 
              <br /><br />
              If I am setting up a payment schedule, I hereby agree to notify <span className="gothammedium-font">{company.name}</span> of any termination of this authorization, 
              or of any changes in my bank account or debit card information, at least one (1) business day prior to the next scheduled payment 
              due date. I understand that to revoke this authorization or to notify <span className="gothammedium-font">{company.name}</span> of any account changes, 
              I should call <span className="gothammedium-font">{company.phone}</span> during its normal business hours <span className="gothammedium-font">({company.workingHour})</span>. 
              I agree that this is a recurring payment event that corresponds to the terms set forth below, 
              and the amount drafted corresponds to my contractual payment amount, which may change due to accrued late fees 
              or unpaid NSF charges (which will appear on my account statements). 
              <br /><br />
              I acknowledge that the origination of electronic fund transactions to or from my account 
              must comply with all applicable provisions of US law and the NACHA rules (as applicable). 
              I also assert that I am the owner of or an authorized signatory on the bank account 
              or that I am the card account holder or an authorized user, as applicable. 
            </p>

            <div className="form-group form-group--row-layout">
              <p className="size-50per no-margin">Payment Amount: <span className="gothammedium-font">{toUSD(this.props.amount)}</span></p>
              <p className="size-50per no-margin">Bank Account: <span className="gothammedium-font">**{this.props.lastFour}</span></p>
            </div>

            {/**
              ** In case we are making a schedule, we must show the payment date, 
              ** the frequency and the number of recurring payments.
              **/}
            { 
              (this.props.isSchedule)
              ? this.renderExtraInfoForSchedule()
              : null
            }

            <div className="form-group form-group--row-layout">
              <PayixButton className="size-50per margin-right-10" onClick={ this.props.onCancel }>
                CANCEL
              </PayixButton>

              <PayixButton className="size-50per margin-right-10" onClick={ this.handleSubmit }>
                SUBMIT
              </PayixButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
 
export default AchTermsConditions;


// WEBPACK FOOTER //
// ./src/components/payment/ach-terms-conditions.js